import { NgModule } from '@angular/core';
import { SharedModule } from 'app/shared/shared.module';
import { AssignRouteComponent } from './assign-route.component';

@NgModule({
    declarations: [
        AssignRouteComponent
    ],
    imports: [
        SharedModule
    ],
    exports: [
        AssignRouteComponent
    ]
})
export class AssignRouteModule {}
